import {gql} from '@apollo/client'

export const SYNCED_ORGANIZATION_IDS = gql`
  query SyncedOrganizationIds($organizationType: OrganizationType!) {
    client {
      id
      syncedOrganizationIds(organizationType: $organizationType)
    }
  }
`

export const LATEST_SYNC_HR_MASTER_TASK = gql`
  query LatestSyncHrMasterTask($organizationType: OrganizationType!) {
    client {
      id
      latestSyncHrMasterTask(organizationType: $organizationType) {
        id
        status
        organizationType
        startedAt
        endedAt
        errorMessage
        diffCsv {
          url
          filename
          file
        }
        confirmed
        createdAt
        outcome
      }
    }
  }
`

export const START_SYNC_HR_MASTER = gql`
  mutation StartSyncHrMaster($input: StartSyncHrMasterInput!) {
    startSyncHrMaster(input: $input) {
      syncHrMasterTask {
        id
        status
        organizationType
        startedAt
        confirmed
      }
    }
  }
`

export const CONFIRM_SYNC_HR_MASTER_TASK = gql`
  mutation ConfirmSyncHrMasterTask($input: ConfirmSyncHrMasterTaskInput!) {
    confirmSyncHrMasterTask(input: $input) {
      syncHrMasterTask {
        id
        confirmed
      }
    }
  }
`

export interface SyncedOrganizationIdsVariables {
  organizationType: OrganizationType
}
export interface SyncedOrganizationIdsResult {
  client: {
    syncedOrganizationIds: string[] | null
  }
}

export interface LatestSyncHrMasterTaskVariables {
  organizationType: OrganizationType
}
export interface LatestSyncHrMasterTaskResult {
  client: {
    latestSyncHrMasterTask: SyncHrMasterTask | null
  }
}

export interface StartSyncHrMasterVariables {
  input: {
    organizationType: OrganizationType
  }
}
export interface StartSyncHrMasterResult {
  startSyncHrMaster: {
    syncHrMasterTask: SyncHrMasterTask
  }
}
export interface ConfirmSyncHrMasterTaskInput {
  id: string
}
export interface SyncHrMasterTask {
  id: string
  status: Status
  organizationType: OrganizationType
  startedAt: string | undefined
  endedAt: string | undefined
  errorMessage: string | null
  diffCsv: FileObjectType | null
  confirmed: boolean
  createdAt: string
  outcome: Outcome | null
}

export interface FileObjectType {
  url: string
  filename: string
  file: string
}

export type Status = 'waiting' | 'in_progress' | 'success' | 'failed'

export type OrganizationType = 'group' | 'employment_type' | 'occupation' | 'position'

export type Outcome = 'diff_created' | 'diff_empty' | 'source_empty'

export const organizationTypeName = (organizationType: OrganizationType) => {
  switch (organizationType) {
    case 'group':
      return 'グループ'
    case 'employment_type':
      return '雇用形態'
    case 'occupation':
      return '職種'
    case 'position':
      return '役職'
  }
}
